import { useMutation } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';

import { StackId } from '../types';

import { buildStackUrl } from './buildUrl';

export interface StackConversionPayload {
  targetFormat: 'kubernetes' | 'helm';
  namespace?: string;
}

export interface StackConversionResponse {
  files: Record<string, string>;
  helmNotSupported?: boolean;
}

export function useStackConversion() {
  return useMutation({
    mutationFn: convertStack,
  });
}

async function convertStack({
  stackId,
  payload,
}: {
  stackId: StackId;
  payload: StackConversionPayload;
}): Promise<StackConversionResponse> {
  try {
    const { data } = await axios.post<StackConversionResponse>(
      buildStackUrl(stackId, 'convert'),
      payload
    );
    return data;
  } catch (err) {
    throw parseAxiosError(err);
  }
}
